import React from "react";
import ChargesItemRow from "./ChargesItemRow";
import "../../../../../css/Finance/Charges/ChargesCategoryCard.css";

const ChargesCategoryCard = ({
  category,
  onAddItem,
  onEditItem,
  onDeleteItem,
}) => {
  return (
    <div className="charges-category-card">
      <div className="charges-category-card-header">
        <h3 className="charges-category-card-title">{category.name}</h3>
        <button
          type="button"
          className="charges-category-card-add-btn"
          onClick={() => onAddItem?.(category.id)}
        >
          + Add charge
        </button>
      </div>
      {!category.items?.length ? (
        <div className="charges-category-card-empty">No charges added yet.</div>
      ) : (
        category.items.map((item) => (
          <ChargesItemRow
            key={item.id}
            item={item}
            onEdit={() => onEditItem?.(category.id, item)}
            onDelete={() => onDeleteItem?.(category.id, item)}
          />
        ))
      )}
    </div>
  );
};

export default ChargesCategoryCard;
